import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Utils } from '../../../services/';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadApplicationType, deleteApplicationType } from '../../../redux/modules/applicationTypes';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';


const ApplicationTypeDelete = () => {
    const { applicationTypeId } = useParams();
    const dispatch     = useDispatch();
    const { t }        = useTranslation();
    const default_lang = Utils.default_lang();

    const { application_type, isLoading, application_typeSuccessfullyDeleted } = useSelector(state => state.applicationTypes);

    useEffect(() => {
        dispatch(loadApplicationType(applicationTypeId));
    }, []);

    const submit = (applicationTypeId) => {
        dispatch(deleteApplicationType(applicationTypeId));
    };

    let title = <span>{t("applicationTypes.applicationType", {count: 42})}</span>;
    if (application_type)
        title = (
            <span>
                <small> |&nbsp;{t('applicationTypes.confirm_delete', { name: application_type.name[default_lang] })}</small>
            </span>
        );

    const actions =
        <div>
            <ButtonGroup>
                <Button tag={Link} to="/application_types" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
                </Button>
            </ButtonGroup>
        </div>

    return (
        <div className="ApplicationTypeDelete">
            <PageTitle icon="address-book" title={title} actions={actions} />

            {application_typeSuccessfullyDeleted &&
                <Redirect to="/application_types" />
            }

            {application_type &&
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle><i className="fa fa-warning"></i>&nbsp;{t('applicationTypes.confirm_delete')}</CardTitle>
                                <CardText tag="div">
                                <div><b>{t("applicationTypes.name")}</b>: {application_type.name[default_lang]}</div>
                                <div dangerouslySetInnerHTML= {{__html: application_type.description[default_lang]}}></div>
                                <Row>
                                        <Col className="text-center">
                                            <Button tag={Link} to="/application_types" color="warning">
                                                <i className="fa fa-arrow-left"></i>&nbsp;{t('common.cancel')}
                                            </Button>&nbsp;
                                            <Button color="danger" onClick={(e) => submit(application_type.id)} disabled={isLoading}>
                                                {isLoading ?
                                                    <span>
                                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                    </span>
                                                    :
                                                    <span>
                                                        <i className="fa fa-trash"></i>&nbsp;
                                                        {t('common.delete')}
                                                    </span>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
        </div>
    );
}

export default ApplicationTypeDelete;
